import { render, staticRenderFns } from "./VerEstimacionIngreso.vue?vue&type=template&id=1ec1cd06"
import script from "./VerEstimacionIngreso.vue?vue&type=script&lang=js"
export * from "./VerEstimacionIngreso.vue?vue&type=script&lang=js"
import style0 from "./VerEstimacionIngreso.vue?vue&type=style&index=0&id=1ec1cd06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports